import { useEffect, useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import { watchQualifyingEvents, watchQualifyingEvent } from '../lib/qualifyingEvents.js'
import PlayerMessageTab from './PlayerMessageTab.jsx'
import CLUB from '../config/club.js'

// Home-reachable Player Message (Quick Actions → /admin/player-message). Works
// with NO built tournament by targeting the active QUALIFYING event's teams and
// writing to qualifyingEvents/{eid}/playerMessage (the app reads it live). The
// shop can pick which event if more than one is open.
const PRIMARY = CLUB.primaryColor || '#123D26'

// Newest OPEN, non-practice event; prefer 4-Ball — mirrors the app's rule.
function pickActiveId(events) {
  const open = Object.entries(events || {})
    .filter(([, v]) => v?.info?.status !== 'closed' && !v?.info?.isPractice)
    .sort((a, b) => (b[1]?.info?.createdAt || 0) - (a[1]?.info?.createdAt || 0))
  const fourBall = open.filter(([, v]) => String(v?.info?.format || '').includes('4-Ball'))
  const chosen = fourBall[0] || open[0]
  return chosen ? chosen[0] : null
}

export default function PlayerMessageStandalone() {
  const [events, setEvents] = useState({})
  const [eventId, setEventId] = useState('')
  const [qEvent, setQEvent] = useState(null)

  useEffect(() => watchQualifyingEvents(setEvents), [])
  // Default to the active event once events load (don't override a manual pick).
  useEffect(() => {
    if (eventId) return
    const active = pickActiveId(events)
    if (active) setEventId(active)
  }, [events, eventId])
  useEffect(() => {
    if (!eventId) { setQEvent(null); return }
    return watchQualifyingEvent(eventId, (v) => setQEvent(v ? { id: eventId, ...v } : null))
  }, [eventId])

  const openEvents = useMemo(
    () => Object.entries(events || {}).filter(([, v]) => v?.info?.status !== 'closed' && !v?.info?.isPractice),
    [events],
  )

  return (
    <div className="p-4 sm:p-8">
      <div className="flex items-center justify-between mb-4">
        <h1 className="text-2xl font-extrabold" style={{ color: '#FFFFFF' }}>📱 Player Message</h1>
        <Link to="/admin" className="text-sm font-bold" style={{ color: '#FFFFFF' }}>← Home</Link>
      </div>

      {openEvents.length === 0 ? (
        <p className="text-sm text-gray-300">No open qualifying event found. Create/open a qualifying event first — Player Message targets its field until a tournament is built.</p>
      ) : (
        <>
          {openEvents.length > 1 ? (
            <div className="mb-4">
              <label className="block text-sm font-extrabold uppercase tracking-widest mb-1" style={{ color: '#FFFFFF' }}>Event</label>
              <select value={eventId} onChange={(e) => setEventId(e.target.value)} className="border rounded-lg px-2 py-2 text-sm w-full max-w-md" style={{ borderColor: '#D1D5DB' }}>
                {openEvents.map(([id, v]) => <option key={id} value={id}>{String(v?.info?.name || id).split('\n')[0]}</option>)}
              </select>
            </div>
          ) : null}

          {qEvent ? (
            <PlayerMessageTab eventId={eventId} qEvent={qEvent} />
          ) : (
            <p className="text-sm text-gray-300">Loading the qualifying field…</p>
          )}
        </>
      )}
    </div>
  )
}
